import React, { useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Row,
  FormGroup,
  CardHeader,
  Container,
  Input,
} from "reactstrap";
import formSchema from "../Utils/schema.json";
import { RenderField } from "../Utils/renderFields";
import { RenderErrorMessage } from "../Utils/renderErrorMessages";
import { LabelText } from "../Utils/Input";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { handleRemoveLogo } from "./Constant/OperatorListingJson";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import StatusBadge from "../Customers/StatusBadge";
// import { handleRemoveLogo } from '../UserManagement/Constant/JsonConstant';
import { ImageUpload } from "../Utils/ImageUpload";
export default function OperatorDetails({
  documentName,
  isEdit,
  values,
  handleChange,
  handleBlur,
  errors,
  touched,
  setFieldTouched,
  setFieldValue,
  countries,
  setSelectedCountry,
  stateData,
  cityData,
  setSelectedState,
  operatorData,
  logoFile,
  imageOn,
  profile,
  setLogoFile,
  setFileSelected,
  fileInputRef,
  setImageOn,
  setUpdate,
  setLoading,
  dispatch,
  operatorId,
  setIsChecked,
  isChecked,
}) {
  const environment = localStorage.getItem("environment");
  const [validateSizeError, setValidateSizeError] = useState(null);
  const isNativeEnvironment = environment === "Native";
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const allowedFormats = ["image/jpeg", "image/png", "image/svg+xml"];
      if (!allowedFormats.includes(file.type)) {
        setValidateSizeError(
          "Invalid file format. Please upload JPEG, PNG, or SVG."
        );
      } else if (file.size / (1024 * 1024) > 10) {
        setValidateSizeError("File size exceeds the limit (10MB)");
      } else {
        setValidateSizeError(null);
        setLogoFile(file);
        setImageOn(true);
        setFileSelected(true);
      }
    } else {
      setLogoFile(null);
      setImageOn(false);
      setFileSelected(false);
    }
  };

  const renderStatusBadge = (status) => {
    switch (status) {
      case "initialized":
        return <StatusBadge value={"Inactive"} />;
      case "validated":
        return <StatusBadge value={"Active"} />;
      case "closed":
        return <StatusBadge value={"Closed"} />;
      default:
        return null;
    }
  };

  return (
    <Container fluid>
      <div className="live-preview">
        {formSchema.map((section, sectionIndex) => (
          <>
            {section.title === "Operator" &&
              section.sections &&
              section.sections.map((subSection, subSectionIndex) => (
                <div key={subSectionIndex} className="mb-4 border py-4 ps-4">
                  {subSection?.sectionTitle && (
                    <div className="align-items-center d-flex mb-3">
                      <h4 className="card-title mb-0 flex-grow-1 rv-form-title">
                        {subSection?.sectionTitle}
                        {subSection?.sectionTitle === "Business Profile" &&
                          operatorData?.status &&
                          isEdit && (
                            <span style={{ marginLeft: "10px" }}>
                              {renderStatusBadge(operatorData?.status)}
                            </span>
                          )}
                      </h4>
                    </div>
                  )}
                  <Row className="gy-4" key={sectionIndex}>
                    <Row>
                      {subSection?.sectionTitle === "Business Profile" && (
                        <Col xxl={3} md={6} key={`${subSectionIndex}-logo`}>
                          {/* <FormGroup className="mt-4">
                            <div className="image-div-tag">
                              <LabelText
                                htmlFor={"logo"}
                                classLabelName={"ms-0 rv-form-label"}
                                displayText={"Photo Upload"}
                              />
                              <LabelText
                                htmlFor={"logo"}
                                classLabelName={`d-block ms-0 rv-sub-label ${validateSizeError
                                    ? "rv-label-danger"
                                    : "rv-label-muted"
                                  } `}
                                displayText={
                                  validateSizeError
                                    ? validateSizeError
                                    : "JPEG, PNG, SVG format, upto 10 MB"
                                }
                              />
                              <div className="image-border-style ms-0">
                                {logoFile ? (
                                  <>
                                    <img
                                      src={
                                        imageOn
                                          ? URL.createObjectURL(logoFile)
                                          : logoFile
                                      }
                                      alt="Logo Preview"
                                      className="to-img-tag"
                                    />
                                    <button
                                      onClick={() =>
                                        handleRemoveLogo(
                                          dispatch,
                                          setLoading,
                                          setLogoFile,
                                          setImageOn,
                                          setUpdate,
                                          fileInputRef,
                                          documentName,
                                          operatorId,
                                          isEdit
                                        )
                                      }
                                      className="img-remove-button"
                                    >
                                      <span className="x-mark">×</span>
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    <label
                                      htmlFor="logoInput"
                                      className="cursor-img"
                                    >
                                      <FileUploadOutlinedIcon
                                        className="fs-1 align-middle me-1 text-secondary"
                                        style={{ transform: "rotate(0deg)" }}
                                      />
                                    </label>
                                  </>
                                )}

                                <input
                                  type="file"
                                  id="logoInput"
                                  name="logo"
                                  accept=".jpg, .jpeg, .png"
                                  style={{ display: "none" }}
                                  onChange={(e) => handleFileChange(e)}
                                  ref={fileInputRef}
                                />
                              </div>
                            </div>
                          </FormGroup> */}
                          <div className="mt-4">
                              <ImageUpload
                            validateSizeError={validateSizeError}
                            profilePicture={logoFile}
                            isProfile={imageOn}
                            inputFileRef={fileInputRef}
                            removeProfilePicture={() => {
                              handleRemoveLogo(
                                dispatch,
                                setLoading,
                                setLogoFile,
                                setImageOn,
                                setUpdate,
                                fileInputRef,
                                documentName,
                                operatorId,
                                isEdit
                              )
                            }}
                            handleImageChange={(e) => {
                              handleFileChange(e)

                            }}
                          ></ImageUpload>
                          </div>
                        </Col>
                      )}
                      <Col
                        lg={
                          subSection?.sectionTitle === "Business Profile"
                            ? 9
                            : 12
                        }
                      >
                        <Row className="gy-4 mt-1">
                          {[...(subSection?.fields || []), ...(subSection?.fieldsOne || [])]
                            ?.filter((field) => {
                              if (field.name === "country" && stateData) {
                                countries.push(stateData);
                              }
                              if (field.name === "state" && cityData) {
                                countries.push(cityData);
                              }
                              if (
                                isEdit &&
                                (field.name === "Domain" ||
                                  field.name === "username" ||
                                  field.name === "email")
                              ) {
                                field.disable = true;
                              } else {
                                field.disable = false;
                              }
                              if (field.name === "Status") {
                                return isEdit;
                              }
                              if (field.name === "isSSOUser") {
                                return false;
                              } 
                              if(values?.Domain?.value !== "SGCAdmin" && field?.name === "Role"){
                                return false;
                              }
                              return true;
                            })
                            .map((field, fieldIndex) => (
                              <Col
                                xxl={
                                  subSection?.sectionTitle ===
                                    "Business Profile"
                                    ? 4
                                    : 3
                                }
                                md={6}
                                lg={4}
                                key={`${subSectionIndex}-${fieldIndex}`}
                              >
                                <LabelText
                                  htmlFor={field.name}
                                  classLabelName={"ms-0 rv-form-label"}
                                  className={
                                    field.required ? "text-danger" : ""
                                  }
                                  displayText={field.label}
                                  important={field.required ? "*" : ""}
                                />
                                <LabelText
                                  htmlFor={field.name}
                                  classLabelName={`d-block ms-0 rv-sub-label ${touched[field.name] && errors[field.name]
                                      ? "rv-label-danger"
                                      : "rv-label-muted"
                                    } `}
                                  displayText={
                                    touched[field.name] && errors[field.name]
                                      ? errors[field.name]
                                      : field.placeholder
                                  }
                                />
                                {field.type === "phone" ? (
                                  <FormGroup>
                                    <PhoneInput
                                      international
                                      countryCallingCodeEditable={false}
                                      className={`form-control ${touched[field.name] &&
                                          errors[field.name]
                                          ? "error-input"
                                          : ""
                                        }`}
                                      // placeholder={field.placeholder}
                                      value={values[field.name]}
                                      onChange={(value) =>
                                        setFieldValue(field.name, value)
                                      }
                                      onBlur={() =>
                                        setFieldTouched(field.name, true)
                                      }
                                      disabled={field?.autoload && field.isEdit}
                                    />
                                  </FormGroup>
                                ) : (
                                  <>
                                    <RenderField
                                      field={field}
                                      handleChange={handleChange}
                                      handleBlur={handleBlur}
                                      values={values}
                                      touched={touched}
                                      errors={errors}
                                      setFieldTouched={setFieldTouched}
                                      setFieldValue={setFieldValue}
                                      options={countries}
                                      setSelectedCountry={setSelectedCountry}
                                      setSelectedState={setSelectedState}
                                      setIsChecked={setIsChecked}
                                      isChecked={isChecked}
                                    />
                                  </>
                                )}
                              </Col>
                            ))}
                        </Row>
                      </Col>
                    </Row>
                  </Row>
                </div>
              ))}
          </>
        ))}
      </div>
    </Container>
  );
}
